<gs1-header rootLink="/hub"  [img]="'../assets/images/logo-gs1-france.png'" [breakWidth]="1080" [connected]="true" [showDisconnect]="false" [profileLabel]="''" [appName]="'Back-office GS1'" 
[profileLabel]="'header.profil' | translate"

>
 
    <a name="header-users" routerLinkActive="active"  (click)="navigateToBannerMarketing()">{{'header.admin.banner' | translate}} </a>
    <a name="header-users" routerLinkActive="active"  (click)="navigateToMaintance()">{{'header.maintenance' | translate}} </a>

    

    <div id="account-popin">
      
        <a name="header-logout" class="gs1-little" (click)="logout()"><i class="bi bi-box-arrow-right"></i> {{'header.deconnecter' | translate}}</a>
    </div>
     
</gs1-header>




